// extracted by mini-css-extract-plugin
module.exports = {"section":"_3gL6zI0y1Hqto7dvrjWOoF","leftSide":"_31No6-VCtj3hHi4l3aTFek","rightSide":"nCFkkN6_qny5SBrYOdeSv","grave":"_9gNnfsGLs2KKs_I-6hWrv"};